export const ACTIVITY_REPORT_MAP_TEXT = {
  emptyValue: '-',
  reportPrefix: 'Reporte:',
  mobileEyebrow: 'Detalle de actividad',
  closeButton: 'Cerrar',
  detailsSectionTitle: 'Detalles de captura de actividad:',
  mapSectionTitle: 'Mapa de ubicacion',
  mapSectionSubtitle:
    'Vista comparativa entre la captura de la actividad y la ubicacion del cliente.',
  activityLabel: 'Actividad',
  dateTimeLabel: 'Fecha y hora',
  geofenceStatusLabel: 'Dentro de geocerca',
  clientLabel: 'Cliente',
  customGeofenceLabel: (distance) => `Geocerca personalizada: ${distance} m`,
  geofenceLegendLabel: (distance) => `Geocerca ${distance} m`
}

export const ACTIVITY_REPORT_MAP_COLORS = {
  geofenceInside: '#50739A',
  geofenceOutside: '#D5422D',
  geofenceNoLocation: '#202020',
  desktopCardBorder: '#D7E3F1',
  desktopCardBottomBorder: '#E6EEF8',
  white: '#FFF',
  desktopGradient:
    'linear-gradient(135deg, rgba(245,249,255,0.98) 0%, rgba(255,255,255,0.98) 100%)',
  desktopSectionTitle: '#17324D',
  desktopSectionSubtitle: '#6B7F95',
  desktopOverline: '#5B7694',
  desktopDetailLabel: '#6B7F95',
  desktopDetailValue: '#17324D',
  detailItemBorder: '#E6EEF8',
  detailItemBackground: '#FFFFFF',
  detailIconBackground: '#EEF5FD',
  detailIconColor: '#27588D',
  chipBorder: '#9FC3E7',
  chipBackground: '#F8FBFF',
  chipText: '#32597D',
  mobileOverline: '#6B7D90',
  mobileTitle: '#203145',
  legendText: '#4A6077',
  activityLegend: '#EF5350',
  clientLegend: '#3CBF47',
  geofenceLegend: '#7F7F7F'
}

export const ACTIVITY_REPORT_MAP_SX = {
  geofenceChip: {
    height: 34,
    borderRadius: 999,
    borderColor: ACTIVITY_REPORT_MAP_COLORS.chipBorder,
    bgcolor: ACTIVITY_REPORT_MAP_COLORS.chipBackground,
    color: ACTIVITY_REPORT_MAP_COLORS.chipText,
    fontWeight: 600,
    '& .MuiChip-label': {
      px: 1.25
    }
  },
  desktopDetailItem: {
    minWidth: 0,
    p: 1.5,
    borderRadius: 2.5,
    border: `1px solid ${ACTIVITY_REPORT_MAP_COLORS.detailItemBorder}`,
    bgcolor: ACTIVITY_REPORT_MAP_COLORS.detailItemBackground
  },
  desktopDetailIcon: {
    width: 32,
    height: 32,
    borderRadius: 1.75,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: ACTIVITY_REPORT_MAP_COLORS.detailIconBackground,
    color: ACTIVITY_REPORT_MAP_COLORS.detailIconColor,
    flexShrink: 0,
    lineHeight: 0,
    '& .MuiSvgIcon-root': {
      display: 'block'
    }
  }
}
